import { render, staticRenderFns } from "./routine-album-detail.vue?vue&type=template&id=3f086b18"
import script from "./routine-album-detail.vue?vue&type=script&lang=js"
export * from "./routine-album-detail.vue?vue&type=script&lang=js"
import style0 from "./routine-album-detail.vue?vue&type=style&index=0&id=3f086b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports